/* eslint-disable */
export default {
  meetingTitle: '{extensionName} 的会议',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
